export function HorizontalTextLine({ children, className = "" }) {
  if (!children) {
    return null;
  }

  return (
    <div className={`decorated-heading ${className}`}>
      <h3 className={`decorated-heading__inner`}>{children}</h3>
    </div>
  );
}

export default HorizontalTextLine;
